import React from "react";
import Button from "components/ui/Button";
import { Link } from "react-router-dom";
import LoginBanner from "components/shared/LoginBanner";

const VerifiedEmail = () => {
    return (
        <div className=" grid grid-cols-1 bg-[#F2F2F2] md:grid-cols-2">
            <div className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32">
                <img className="h-20 w-20" src="./img/checkbox-object.png" alt="" />
                <div className="mt-2 text-3xl font-bold">Your email is verified</div>
                <div className="mt-2 text-lightGrey">
                    You are all set, email is already verified
                </div>
                <Link to="/dashboard" className="mt-9">
                    <Button title="Continue to Login" />
                </Link>
                <div className="mt-3 flex  text-xs font-semibold gap-1">
                    <div className="text-lightGrey">Need Help?</div>
                    <a className="text-secondary" href="/login">
                        Visit Support
                    </a>
                </div>
            </div>
            <LoginBanner />
        </div>
    );
};

export default VerifiedEmail;
